/**
 * The metered features an operator may price PER-PLAN and PER-TENANT.
 *
 * Relocated here from `features/files/api/admin.ts` (where it was a server-only
 * const) so the browser can import it too: the plan-CREATE draft flow
 * (`features/billing/ui`) seeds a blank feature-pricing grid from this list
 * before any plan row exists, and `features/billing/ui` cannot import server
 * code. The server still imports it from here — there is ONE copy.
 *
 * Excludes `'llm'` (priced per-model upstream, never flows through
 * `feature_pricing`) and `'storage'` (QUOTA-enforced since 0171, never
 * metered — pricing a surface the ledger never records is a rate nothing
 * multiplies). `shared/types/src/__tests__/priceable-features-sync.test.ts`
 * guards both exclusions and that every entry is also a `METERED_FEATURES`
 * one on the server.
 */
export const PER_TENANT_PRICEABLE = ['sandbox_compute', 'web_search'] as const

export type PriceableFeature = (typeof PER_TENANT_PRICEABLE)[number]
